import $ from "jquery";

$(document).on("turbolinks:load", function() {
  $("#card-forms-wrapper .create-or-update-commit-button, #company-forms-wrapper .create-or-update-commit-button, #psp-project-forms-wrapper .create-or-update-commit-button, #asset-forms-wrapper .create-or-update-commit-button").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    $("#assign-to-user-container").modal("show");
  });

  $("#card-forms-wrapper .approve-commit-button:not(.part-of-major-revision), #company-forms-wrapper .approve-commit-button, #psp-project-forms-wrapper .approve-commit-button, #asset-forms-wrapper .approve-commit-button").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    $("#mark-as-significant-container").modal("show");
  });
});
